import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationMaterializeCopilotImportArgs } from 'src/types/backend';

export interface CopilotImportPayload {
  project: { id: string };
}

const MUTATION = gql`
  mutation MaterializeCopilotImport($jobId: ID!) {
    materializeCopilotImport(jobId: $jobId) {
      project {
        id
      }
    }
  }
`;

type Variables = BackendMutationMaterializeCopilotImportArgs;

export const materializeCopilotImport = async (
  variables: Variables
): Promise<CopilotImportPayload> => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });

  return getSingleProp(result.data) as CopilotImportPayload;
};
